import { createRoutine } from 'redux-saga-routines';

export const setContactInfoErrorRoutine = createRoutine('SET_MERGED_CONTACT_INFO_ERROR');
export const mergeContactsRoutine = createRoutine('MERGE_CONTACTS');
